'use strict';

import $ from 'jquery';

/**
 * Handle add/delete availability events
 *
 * @param {'availability_add'|'availability_delete'} actionType
 * @param {HTMLElement} triggerElement
 */
const availabilityHandler = async function (actionType, triggerElement) {

	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const product_id = String(triggerElement.dataset.availabilityToggle || '');
	const sendData = [{ product_id }];
	const extraOptions = elemData;

	// sendData must be array
	if (!product_id) {
		mpro.toast('error', 'Missing or invalid data');
		return;
	}

	// Availability api
	const inventory = mpro.shop.inventory;
	// Get override success/error actions from extra options
	const overrideActions = inventory.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await inventory[actionType]({ items: sendData });
		// Execute all defined success handlers for the current action
		inventory.runSuccessHandlers(actionType, res, triggerElement, overrideActions.success);
	}
	catch (err) {
		// Default error handler
		inventory.runErrorHandlers(actionType, err, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
};

/**
 * Handle clear user list events
 *
 * @param {HTMLElement} triggerElement
 */
const userListClearHandler = async function (e) {

	e.preventDefault();

	const triggerElement = this;
	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const extraOptions = elemData;

	// Availability api
	const inventory = mpro.shop.inventory;
	// Get override success/error actions from extra options
	const overrideActions = inventory.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await inventory['userlist_clear']();
		// Execute all defined success handlers for the current action
		inventory.runSuccessHandlers('userlist_clear', res, triggerElement, overrideActions.success);
	}
	catch (err) {
		// Default error handler
		inventory.runErrorHandlers('userlist_clear', err, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
}

/**
 * Handle set user list events
 *
 * @param {HTMLElement} triggerElement
 */
const userListSetHandler = async function (triggerElement) {

	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const product_id = String(triggerElement.dataset.userListSet || '');
	const qty = Number($trigger.val() || 0);
	const sendData = [{ product_id, qty }];
	const extraOptions = elemData;

	// sendData must be array
	if (!product_id) {
		mpro.toast('error', 'Missing or invalid data');
		return;
	}

	// Availability api
	const inventory = mpro.shop.inventory;
	// Get override success/error actions from extra options
	const overrideActions = inventory.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await inventory['userlist_set']({ items: sendData });

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const mode = urlParams.get('mode');
		if (mode === 'userlist') {
			if (sendData[0].qty === 0) {
				overrideActions.success.desktop = [{'remove_closest': ['.product']}, 'refresh_if_empty'];
				overrideActions.success.mobile = [{'remove_closest': ['.product']}, 'refresh_if_empty'];
			}
		}

		// Execute all defined success handlers for the current action
		inventory.runSuccessHandlers('userlist_set', res, triggerElement, overrideActions.success);
	}
	catch (err) {
		// Default error handler
		inventory.runErrorHandlers('userlist_set', err, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
}

/**
 * Handle vendor wishlist events
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
const throttleUserListSet = function(e) {
	const $elem = $(this);
	const data = $elem.data();

	if (data._throttleTimer) {
		window.clearTimeout(data._throttleTimer);
	}

	data._throttleTimer = window.setTimeout(userListSetHandler, 833, this);
};

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate($ => {

	const $B = mpro.get$B();

	// Handle click event for update-cart spinners
	$B.on('click.userListClear', 'a[data-user-list-clear]', userListClearHandler);

	// Handle click event for update-cart spinners
	$B.on('change.userListSet', 'input[data-user-list-set]', throttleUserListSet);

	// Handle click event for add and remove availability buttons
	$B.on('click.availabilityToggle', 'input[data-availability-toggle]', function (e) {
		// Delete from availability
		if (!this.checked) {
			availabilityHandler('availability_delete', this);
		}
		// Default to add to availability
		else {
			availabilityHandler('availability_add', this);
		}
	});
});
